(() => {
  'use strict';
  if (window.KinFabricJourney) return;
  const contextKeys = ['model', 'variant', 'preview_theme_id'];
  const fromKey = 'fabric_from', labelKey = 'fabric_from_label';
  const detail = document.querySelector('[data-fabric-page]');
  const index = document.querySelector('[data-fabrics-index]');
  const hay = !detail && document.querySelector('#fabric-library');
  const config = document.querySelector('script[data-fabric-journey]')?.dataset || {};
  const copy = {
    hay: config.backHay || 'Back to HAY fabrics',
    tradition: config.backTradition || 'Back to &Tradition fabrics',
    all: config.backAll || 'Back to all fabrics',
    short: config.allShort || 'All fabrics',
    source: config.backSource || 'Back to [source]',
    previous: config.backPrevious || 'Back to previous page'
  };
  const text = value => String(value || '').replace(/[\u0000-\u001f]/g, '').replace(/\s+/g, ' ').trim().slice(0, 100);
  function localSource(raw) {
    if (typeof raw !== 'string' || raw.length > 2048 || !raw.startsWith('/') || raw.startsWith('//')) return null;
    try {
      const decoded = decodeURIComponent(raw);
      if (/^[\/]{2}|[\\\u0000-\u001f]/.test(decoded)) return null;
      const url = new URL(raw, location.origin);
      if (url.origin !== location.origin || !/^\/(pages|products|collections|blogs)\//.test(url.pathname)) return null;
      if (detail && url.pathname === location.pathname && url.searchParams.get('view') === new URL(location.href).searchParams.get('view')) return null;
      return url;
    } catch { return null; }
  }
  function sourceLabel(url, supplied) {
    const view = url.searchParams.get('view') || '';
    if (url.pathname === '/pages/fabrics' || view === 'kin-fabric-index') return copy.all;
    if (url.pathname === '/pages/andtradition-fabrics' || view === 'kin-andtradition-fabrics') return copy.tradition;
    if (url.pathname === '/pages/hay-fabric-options' && !view) return copy.hay;
    return supplied ? copy.source.replace('[source]', text(supplied)) : copy.previous;
  }
  const initial = new URL(location.href);
  let origin = localSource(initial.searchParams.get(fromKey));
  let originTitle = text(initial.searchParams.get(labelKey));
  if (!origin && detail && document.referrer) {
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin === location.origin) origin = localSource(referrer.pathname + referrer.search + referrer.hash);
    } catch {}
  }
  function context(url) {
    const current = new URL(location.href);
    for (const key of contextKeys) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    return url;
  }
  const relative = url => url.pathname + url.search + url.hash;
  function browseSource(card) {
    const url = new URL(location.href);
    url.searchParams.delete(fromKey); url.searchParams.delete(labelKey);
    url.searchParams.delete('colour');
    url.hash = card?.id || (hay ? 'fabric-library' : 'fabric-directory');
    return url;
  }
  function isFabric(url) {
    return url.pathname.startsWith('/pages/fabric-') || /^kin-fabric-(?!index$)/.test(url.searchParams.get('view') || '');
  }
  function link(path, card) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return url.href;
    context(url);
    if (isFabric(url)) {
      const source = detail ? origin : (index || hay ? browseSource(card) : null);
      url.searchParams.delete(fromKey); url.searchParams.delete(labelKey);
      if (source) {
        url.searchParams.set(fromKey, relative(source));
        const title = detail ? originTitle : text(document.querySelector('main h1')?.textContent);
        if (title) url.searchParams.set(labelKey, title);
      }
    }
    return url.href;
  }
  function applyOrigin() {
    const libraryOrigin = origin && (origin.pathname === '/pages/fabrics' || origin.searchParams.get('view') === 'kin-fabric-index');
    document.querySelectorAll('[data-fabric-origin-link]').forEach(anchor => {
      anchor.hidden = !origin || libraryOrigin;
      if (!origin) return;
      anchor.href = context(new URL(origin.href)).href;
      anchor.querySelector('span').textContent = sourceLabel(origin, originTitle);
    });
    document.querySelectorAll('[data-fabric-library-link]').forEach(anchor => {
      if (!detail) { anchor.href = link(anchor.href); return; }
      anchor.href = libraryOrigin ? context(new URL(origin.href)).href : context(new URL('/pages/fabrics', location.origin)).href;
      anchor.querySelector('span').textContent = origin && !libraryOrigin ? copy.short : copy.all;
    });
    if (origin) document.querySelectorAll('[data-fabric-return]').forEach(anchor => {
      anchor.href = context(new URL(origin.href)).href;
      const words = anchor.querySelector('.kf-action-label,span');
      if (words) words.textContent = sourceLabel(origin, originTitle);
    });
  }
  function refresh(scope = document) {
    scope.querySelectorAll('[data-fabric-link],[data-fabric-explore],[data-kin-colour-open],[data-preserve-context]').forEach(anchor => {
      anchor.href = link(anchor.href, anchor.closest('[data-fabric-card]'));
    });
    applyOrigin();
  }
  function formReturn() {
    const current = new URL(location.href), kept = new URLSearchParams();
    for (const key of ['view', 'colour', 'fabric_search', 'fabric_maker', 'fabric_group', ...contextKeys]) {
      if (current.searchParams.has(key)) kept.set(key, current.searchParams.get(key));
    }
    if (origin) {
      kept.set(fromKey, relative(origin));
      if (originTitle) kept.set(labelKey, originTitle);
    }
    return current.pathname + (kept.size ? '?' + kept.toString() : '') + '#kf-sample-request';
  }
  function setBrowse(values) {
    const url = new URL(location.href);
    for (const [key, value] of Object.entries(values)) {
      if (!['fabric_search', 'fabric_maker', 'fabric_group'].includes(key)) continue;
      const clean = text(value);
      if (clean) url.searchParams.set(key, clean); else url.searchParams.delete(key);
    }
    history.replaceState(null, '', url);
    refresh();
  }
  function setProduct(title, path) {
    if (!origin) return;
    const product = new URL(path, location.origin);
    if (origin.origin === product.origin && origin.pathname === product.pathname) { originTitle = text(title); applyOrigin(); }
  }
  window.KinFabricJourney = {link, refresh, setBrowse, formReturn, setProduct, get hasOrigin() { return !!origin; }};
  if (detail?.dataset.fabricCanonical) {
    const canonical = new URL(detail.dataset.fabricCanonical, location.origin);
    if (canonical.origin === location.origin && canonical.pathname !== location.pathname && /^kin-fabric-/.test(initial.searchParams.get('view') || '')) {
      for (const key of ['colour', ...contextKeys]) if (initial.searchParams.has(key)) canonical.searchParams.set(key, initial.searchParams.get(key));
      if (origin) { canonical.searchParams.set(fromKey, relative(origin)); if (originTitle) canonical.searchParams.set(labelKey, originTitle); }
      canonical.hash = initial.hash;
      location.replace(canonical.href);
      return;
    }
  }
  refresh();
  document.addEventListener('shopify:section:load', event => refresh(event.target));
})();
